import Model from "@/models/Model"

export default class ARestorePassword extends Model {
    resource() {
        return "password"
    }
}